// facade for future overrides / extensions
const env = window.LEAF_HOME_CZVOUCHER ?? {};

export { env };
